module.exports = __webpack_public_path__ + "img/lw-logo-name-dark.2aabe687.png";